module.exports = {"id":"166744","name":"Mikhail Kerzhakov","rating":"73","photo":"./data/images/photos/0/166744.png","club":{"name":"Zénith","logo":"./data/images/clubs/Zenith.png"},"positions":["G"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MikhailKerzhakov0.json
// module id = 3029
// module chunks = 0